module.exports = __webpack_public_path__ + "img/hant.ba67d50f.svg";